export default {
  remove: {
    id: 'selected_catch_up_offer_remove',
    defaultMessage: 'Remove',
  },
}
